'use client'
import Link from 'next/link'
import { useAuth } from '@/context/AuthContext'
import { trackEvent } from '@/lib/trackEvent'

export default function GuestHeroBanner({ dealCount = 0 }) {
  const { currentUser } = useAuth()
  if (currentUser) return null

  const count = dealCount > 0 ? dealCount.toLocaleString() : null

  return (
    <div className="bg-blue-600 px-4 py-7 sm:py-9">
      <div className="max-w-4xl mx-auto">
        <p className="text-sm text-blue-200 mb-2">FairFares · automated deal scanning</p>
        <h2 className="text-2xl sm:text-3xl font-bold text-white leading-snug mb-3">
          Genuine flight deals,<br className="hidden sm:block" /> found by AI.
        </h2>
        <p className="text-sm text-blue-100 mb-5">
          {count ? <><strong className="text-white font-semibold">{count}</strong> routes with deals</> : 'Thousands of routes with deals'}
          {' · '}updated hourly · no markup — you pay the airline price
        </p>
        <div className="flex flex-wrap gap-3">
          <Link
            href="/signup"
            onClick={() => trackEvent('signup_cta', { label: 'Sign up free', component: 'GuestHeroBanner' }, 'guest')}
            className="rounded-lg bg-white px-5 py-2.5 text-sm font-bold text-blue-700 hover:bg-blue-50 transition-colors"
          >
            Sign up free →
          </Link>
          <Link
            href="/deals"
            className="rounded-lg border border-blue-300/60 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-500 transition-colors"
          >
            Browse all deals
          </Link>
        </div>
      </div>
    </div>
  )
}
